import { makeId } from '@/utils/makeId'

export type Additional = {
  id: string
  name: string
  description: string
  price: number
}

export const additional: Additional[] = [
  // {
  //   id: makeId(),
  //   name: 'Pingos de Chocolate',
  //   description: 'Pingos de chocolate nobre no meio do seu bolo',
  //   price: 9.99,
  // },
  {
    id: makeId(),
    name: 'KitKat®',
    description: 'KitKat® original ao redor do seu bolo',
    price: 15.99,
  },
  {
    id: makeId(),
    name: 'M&M´s®',
    description: 'M&M´s® original por cima do seu bolo',
    price: 15.99,
  },
]
